export enum OrderChannel {
  TABLE = "TABLE",
  COUNTER = "COUNTER",
  TAKEAWAY = "TAKEAWAY",
  DELIVERY = "DELIVERY",
  DELIVERY_LOCAL = "DELIVERY_LOCAL",
  ONLINE = "ONLINE", // Online order channel
}

export const OrderChannelLabels = {
  [OrderChannel.TABLE]: "Table Service",
  [OrderChannel.COUNTER]: "Counter",
  [OrderChannel.TAKEAWAY]: "Takeaway",
  [OrderChannel.DELIVERY]: "Delivery",
  [OrderChannel.DELIVERY_LOCAL]: "Local Delivery",
  [OrderChannel.ONLINE]: "Online",
};

// Note: Icons are now imported from react-icons, not emojis
// Use MdOutlineTableRestaurant from react-icons/md for TABLE
export const OrderChannelIcons = {
  [OrderChannel.TABLE]: "TABLE", // Use icon component instead
  [OrderChannel.COUNTER]: "🏪",
  [OrderChannel.TAKEAWAY]: "📦",
  [OrderChannel.DELIVERY]: "🚚",
  [OrderChannel.DELIVERY_LOCAL]: "🛵",
};
